import React from 'react';

export default function StrategyBulbIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M8.5 17.5c0-2.5-3-3.6-3-7a6.5 6.5 0 0 1 13 0c0 3.4-3 4.5-3 7" />
      <path d="M8.5 17.5h7v2h-7zM10 21.5h4" />
      <path d="M12 1V0M4.6 3.6 3.2 2.2M2 10.5H0.5M4.6 17.4l-1.4 1.4M19.4 3.6l1.4-1.4M22 10.5h1.5M19.4 17.4l1.4 1.4" />
    </svg>
  );
}
